import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarX = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 5.5,
			width: 16,
			height: 14.5,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M4 10.5h16M8.5 3.5v4M15.5 3.5v4" }),
		/* @__PURE__ */ _jsx("path", { d: "m14 13-4 4M10 13l4 4" })
	]
});
const ForwardRef = forwardRef(SvgCalendarX);
export default ForwardRef;
